import {
  enableOutfits,
  enableProductCompare,
  checkoutComponent,
  enableWishList,
  enableSubscription,
  IS_BROWSER,
} from 'config/appConfig'

import { getSeparateCartAndCheckout } from 'config/appConfig/configUtils'
import { enableJitsuSF } from 'src/utils/commonUtils'

const pageNames = {
  home: '/',
  equinoxMysite: '/mysite/',
  equinoxPersonalOffer: '/personal-offer',
  mysitePreview: '/preview',
  loginCallback: '/login/callback',
  logoutCallback: '/logout/callback',
  catalog: '/catalog',
  categoryLanding: '/categoryLanding',
  subscription: '/product/subscribe',
  product: '/product',
  expressPDP: '/expressProduct',
  checkout: '/checkout',
  expressCheckout: '/expressCheckout',
  orderConfirmation: '/orderConfirmation',
  return: '/order-returns',
  returnSteps: '/order-returns/steps',
  returnConfirmation: '/order-returns/confirmation',
  returnGuestSteps: '/order-returns/guest',
  signUp: '/signup',
  inviteLanding: '/signup/invite-landing',
  signUpModalBrand: `/static/signup/:type/signup-page`,
  signUpModalAssociate: `/associateActivation`,
  signIn: '/signin',
  associateStatic: `/associateInvitationStatic`,
  search: '/search',
  orderLookup: '/orderlookup',
  resetPassword: '/resetPassword',
  userActivation: '/userActivation',
  configs: '/configs',
  status: '/status',
  favorites: '/favorites',
  storeLocator: '/storeLocator',
  createAccount: '/register',
  myaccount: '/myaccount/:accountTab?',
  myaccountprofile: '/myaccount/welcome',
  myaccountorders: '/myaccount/orderhistory',
  security: '/myaccount/security',
  myaccountvolumes: '/myaccount/volumes',
  myaccountshipping: '/myaccount/address',
  myaccountpayment: '/myaccount/payments',
  myaccountsettings: '/myaccount/settings',
  myaccountsubscriptions: '/myaccount/subscriptions',
  manageSubscription: '/myaccount/manageSubscription',
  myaccountmycloset: '/myaccount/mycloset',
  myaccountlists: '/myaccount/listsmanagement',
  myaccountrewardsandcredits: '/myaccount/rewardsandcredits',
  myaccountfavourites: '/myaccount/favorites',
  myaccountprivacy: '/myaccount/privacy',
  myaccountdirectselleridcard: '/myaccount/directselleridcard',
  myaccountwallet: '/myaccount/wallet',
  myaccountdeposit: '/myaccount/directdeposit',
  mysite: '/myaccount/mysite',
  mysiteAdmin: '/mysite-admin',
  b2bDashBoard: '/myaccount/dashboard',
  b2bMyProfile: '/myaccount/myprofile',
  b2bAccountProfile: '/myaccount/accountprofile',
  b2bAccountTypeConvert: '/myaccount/accounttype',
  b2bApprovals: '/myaccount/approvals',
  b2bUserManagement: '/myaccount/usermanagement',
  participants: '/myaccount/participants',
  b2bContractList: '/myaccount/contracts',
  b2bAddressBook: '/myaccount/address',
  b2bCostCenter: '/myaccount/costcenter',
  b2bTeamManagement: '/myaccount/teammanagement',
  viewCart: '/viewCart',
  SharedList: '/sharedlist',
  productCompare: '/products/compare',
  SelectRegion: '/selectregion',
  LoyaltyDashboard: '/loyalty_landing',
  myAccountPrefix: '/myaccount',
  poSubscripiton: '/subscriptions',
  klarnaCheckout: '/klarnaCheckout',
  subscriptionCart: '/subscriptionCart',
  subscriptionCheckout: '/subscriptionCheckout',
  accountSettings: '/myaccount/accountsettings',
  jitsuParticipantsInvite: '/site/participant-invite',
  jitsuSignUp: '/site/signup',
  typeSensePoc: '/search-poc',
  welcome: '/welcome',
  mysiteCategories: '/mysite-categories',
  inviteLinkBuilder: '/invite-link-builder',
  BAAccountConversionForIN: '/account/conversion',
  VDIConversionForFR: '/account/vdi-conversion',
  productOfferAdmin: '/myaccount/productoffer',
  shareOffer: '/share-offer',
}

const b2cAccountSubRoutes = [
  {
    path: `${pageNames.myaccountprofile}`,
    pageComponentName: 'MyAccount/MyAccountProfile',
  },
  {
    path: `${pageNames.myaccountorders}`,
    pageComponentName: 'MyAccount/Orders',
  },
  {
    path: `${pageNames.myaccountshipping}`,
    pageComponentName: 'MyAccount/Address',
  },
  {
    path: `${pageNames.myaccountpayment}`,
    pageComponentName: 'MyAccount/Payments',
  },
  {
    path: `${pageNames.myaccountsettings}`,
    pageComponentName: 'MyAccount/Settings',
  },
  {
    path: `${pageNames.myaccountrewardsandcredits}`,
    pageComponentName: 'MyAccount/Loyalty',
  },
  {
    path: `${pageNames.myaccountrewardsandcredits}`,
    pageComponentName: 'MyAccount/Loyalty',
  },
  {
    path: `${pageNames.myaccountwallet}`,
    pageComponentName: 'MyAccount/Wallet',
  },
  {
    path: `${pageNames.myaccountprivacy}`,
    pageComponentName: 'MyAccount/Privacy',
  },
  {
    path: `${pageNames.myaccountdirectselleridcard}`,
    pageComponentName: 'MyAccount/DirectSellerIdCard',
  },
  {
    path: `${pageNames.myaccountfavourites}`,
    pageComponentName: 'MyAccount/Favorites',
  },
  {
    path: `${pageNames.myaccountdeposit}`,
    pageComponentName: 'MyAccount/DirectDeposite',
  },
  enableWishList && {
    path: `${pageNames.myaccountlists}`,
    pageComponentName: 'MyAccount/ListsManagement',
  },
  enableSubscription && {
    path: `${pageNames.myaccountsubscriptions}`,
    pageComponentName: 'MyAccount/Subscriptions',
  },

  enableOutfits && {
    path: `${pageNames.myaccountmycloset}`,
    pageComponentName: 'MyAccount/MyCloset',
  },
  {
    path: `${pageNames.manageSubscription}`,
    pageComponentName: 'MyAccount/Subscriptions',
  },
  {
    path: `${pageNames.accountSettings}`,
    pageComponentName: 'MyAccount/AccountSettings',
  },
  {
    path: `${pageNames.productOfferAdmin}`,
    pageComponentName: 'MyAccount/ProductOffer',
  },
].filter(Boolean)

// enableWishList &&
//   b2cAccountSubRoutes.push({
//     path: `${pageNames.myaccountlists}`,
//     pageComponentName: 'MyAccount/ListsManagement',
//   })

// b2cAccountSubRoutes.push({
//   path: `${pageNames.myaccountsettings}`,
//   pageComponentName: 'MyAccount/Settings',
// })

// enableSubscription &&
//   b2cAccountSubRoutes.push({
//     path: `${pageNames.myaccountsubscriptions}`,
//     pageComponentName: 'MyAccount/Subscriptions',
//   })

// b2cAccountSubRoutes.push({
//   path: `${pageNames.myaccountrewardsandcredits}`,
//   pageComponentName: 'MyAccount/Loyalty',
// })

// b2cAccountSubRoutes.push({
//   path: `${pageNames.myaccountprivacy}`,
//   pageComponentName: 'MyAccount/Privacy',
// })

// b2cAccountSubRoutes.push({
//   path: `${pageNames.myaccountfavourites}`,
//   pageComponentName: 'MyAccount/Favorites',
// })

// b2cAccountSubRoutes.push({
//   path: `${pageNames.myaccountdeposit}`,
//   pageComponentName: 'MyAccount/DirectDeposite',
// })

// enableOutfits &&
//   b2cAccountSubRoutes.push({
//     path: `${pageNames.myaccountmycloset}`,
//     pageComponentName: 'MyAccount/MyCloset',
//   })

const b2bAdminSubRoutes = [
  {
    path: `${pageNames.b2bDashBoard}`,
    pageComponentName: 'MyAccount/Dashboard/Dashboard',
  },
  {
    path: `${pageNames.b2bMyProfile}`,
    pageComponentName: 'MyAccount/MyAccountProfile',
  },
  {
    path: `${pageNames.b2bAccountProfile}`,
    pageComponentName: 'MyAccount/B2BAccountProfile',
  },
  {
    path: `${pageNames.b2bAccountTypeConvert}`,
    pageComponentName: 'MyAccount/ConvertAccountType', //B2BAccountConvert',
  },
  {
    path: `${pageNames.myaccountorders}`,
    pageComponentName: 'MyAccount/Orders',
  },
  {
    path: `${pageNames.security}`,
    pageComponentName: 'MyAccount/Security',
  },
  {
    path: `${pageNames.mysite}`,
    pageComponentName: 'MyAccount/MySite',
  },
  {
    path: `${pageNames.myaccountvolumes}`,
    pageComponentName: 'MyAccount/Volumes',
  },
  {
    path: `${pageNames.b2bUserManagement}`,
    pageComponentName: 'MyAccount/UserManagement',
  },
  {
    path: `${pageNames.participants}`,
    pageComponentName: 'MyAccount/UserManagement/Participants',
  },
  {
    path: `${pageNames.b2bCostCenter}`,
    pageComponentName: 'MyAccount/CostCenter',
  },
  {
    path: `${pageNames.b2bTeamManagement}`,
    pageComponentName: 'MyAccount/TeamManagement',
  },
  {
    path: `${pageNames.b2bContractList}`,
    pageComponentName: 'MyAccount/Contracts',
  },
  {
    path: `${pageNames.accountSettings}`,
    pageComponentName: 'MyAccount/AccountSettings',
  },
]

const combineSubRoutes = [...b2bAdminSubRoutes, ...b2cAccountSubRoutes]
const accountSubRoutes = Array.from(
  new Set(combineSubRoutes.map(route => route.path))
).map(path => {
  return combineSubRoutes.find(route => route.path === path)
})

const isDevEnvironment = () => {
  /**
   * @note
   * here, we are skipping the configs page
   * for higher environments
   */
  if (IS_BROWSER) {
    return (
      window.location.host.includes('-dev1') ||
      window.location.host.includes('-dev2') ||
      window.location.host.includes('local')
    )
  }
  return false
}
const enableJitsuFromStorefront = enableJitsuSF()

const pathParams = [
  {
    path: pageNames.mysiteCategories,
    pageComponentName: 'MysitePLP',
  },
  {
    path: pageNames.home,
    pageComponentName: 'StudioPage',
  },
  {
    path: pageNames.mysitePreview,
    pageComponentName: 'StudioPage',
  },
  {
    path: pageNames.loginCallback,
    pageComponentName: 'LoginCallback',
  },
  {
    path: pageNames.logoutCallback,
    pageComponentName: 'LogoutCallback',
  },
  {
    path: `${pageNames.search}/:searchTerm`,
    pageComponentName: 'Catalog',
  },
  {
    path: `${pageNames.catalog}/:catalogId`,
    pageComponentName: 'Catalog',
  },
  {
    path: `${pageNames.product}/:productId`,
    pageComponentName: 'ExpressPDP',
  },
  {
    path: `${pageNames.expressPDP}/:productId`,
    pageComponentName: 'ExpressPDP',
  },
  {
    path: pageNames.inviteLanding,
    pageComponentName: 'SignUp',
  },
  {
    path: `${pageNames.signUp}`,
    pageComponentName: 'SignUp',
  },
  enableJitsuFromStorefront && {
    path: pageNames.jitsuParticipantsInvite,
    pageComponentName: 'SignUp',
  },
  /**
   * @note NGE1-3457
   * When JITSU is hosted from storefront, `/signup` is the canonical
   * destination and never redirects to `/site/signup`.
   */
  enableJitsuFromStorefront && {
    path: pageNames.jitsuSignUp,
    pageComponentName: 'SignUp',
  },
  {
    path: `${pageNames.signUpModalBrand}`,
    pageComponentName: 'SignUpModal',
    isExact: false,
  },
  {
    path: `${pageNames.signUpModalAssociate}`,
    pageComponentName: 'SignUpModal',
    isExact: false,
  },
  {
    path: `${pageNames.associateStatic}`,
    pageComponentName: 'AssociateStatic',
    isExact: false,
  },
  {
    path: `${pageNames.myaccount}`,
    pageComponentName: 'DynamicAccount',
    routes: accountSubRoutes,
  },
  {
    path: `${pageNames.signIn}`,
    pageComponentName: 'SignIn',
  },
  /**
   * to render checkout and express checkout components dynamically
   * based on the environment variables
   */
  {
    path: `${pageNames.checkout}`,
    pageComponentName: 'DynamicCheckout',
  },
  {
    path: `${pageNames.expressCheckout}`,
    pageComponentName: 'ExpressCheckout',
  },
  {
    path: `${pageNames.subscriptionCheckout}`,
    pageComponentName: 'ExpressCheckout',
  },
  {
    path: `${pageNames.orderLookup}`,
    pageComponentName: 'OrderLookUp',
  },
  {
    path: `${pageNames.orderConfirmation}`,
    pageComponentName: 'OrderConfirmation',
  },
  {
    path: `${pageNames.return}`,
    pageComponentName: 'Returns',
  },
  {
    path: `${pageNames.returnSteps}`,
    pageComponentName: 'Returns',
  },
  {
    path: `${pageNames.returnConfirmation}`,
    pageComponentName: 'Returns',
  },
  {
    path: `${pageNames.returnGuestSteps}`,
    pageComponentName: 'Returns',
  },
  {
    path: `${pageNames.userActivation}`,
    pageComponentName: 'ResetPassword',
    isExact: false,
  },
  {
    path: `${pageNames.categoryLanding}/:categoryId`,
    pageComponentName: 'CategoryLanding',
  },
  {
    path: `${pageNames.favorites}`,
    pageComponentName: 'Favorites',
  },
  isDevEnvironment() && {
    path: `${pageNames.configs}`,
    pageComponentName: 'Config',
  },
  {
    path: `${pageNames.status}`,
    pageComponentName: 'Status',
  },
  {
    path: `${pageNames.SharedList}`,
    pageComponentName: 'SharedList',
  },
  {
    path: `${pageNames.SelectRegion}`,
    pageComponentName: 'SelectRegion',
  },
  {
    path: `${pageNames.inviteLinkBuilder}`,
    pageComponentName: 'InviteLinkBuilder',
  },
  {
    path: `${pageNames.BAAccountConversionForIN}`,
    pageComponentName: 'MyAccount/ConvertAccountType/SignzyAccountConversion',
  },
  {
    path: `${pageNames.VDIConversionForFR}`,
    pageComponentName: 'MyAccount/ConvertAccountType/SignzyAccountConversion',
  },
  {
    path: `${pageNames.klarnaCheckout}`,
    pageComponentName: 'KlarnaCheckout',
  },
  enableSubscription && {
    path: `${pageNames.subscription}/:productId`,
    pageComponentName: 'Subscription',
  },
  getSeparateCartAndCheckout() && {
    path: `${pageNames.viewCart}`,
    pageComponentName: 'DynamicCart',
  },
  {
    path: `${pageNames.subscriptionCart}`,
    pageComponentName: 'DynamicCart',
  },
  enableProductCompare && {
    path: `${pageNames.productCompare}`,
    pageComponentName: 'ProductsCompare',
  },
  {
    path: `${pageNames.LoyaltyDashboard}`,
    pageComponentName: 'LoyaltyDashboard',
  },
  {
    path: `${pageNames.mysiteAdmin}`,
    pageComponentName: 'MySiteAdmin/MySiteAdmin',
  },
  {
    path: `${pageNames.typeSensePoc}`,
    pageComponentName: 'TypeSensePoc',
  },
  {
    path: `${pageNames.welcome}`,
    pageComponentName: 'Welcome',
  },
  {
    path: `${pageNames.equinoxPersonalOffer}/:sponsorId`,
    pageComponentName: 'PersonalOffer',
    isExact: false,
  },
  {
    path: pageNames.shareOffer,
    pageComponentName: 'ShareOfferPage',
  },
  {
    path: `*`,
    pageComponentName: 'NotFound',
  },
].filter(Boolean)

export {
  pathParams,
  pageNames,
  accountSubRoutes,
  b2bAdminSubRoutes,
  b2cAccountSubRoutes,
}
export default pathParams
